/* eslint-disable */
import { IState } from "@/interfaces/IState";
import axios from "axios";

export const resource = {
    state: {
        resources: [],
        resourcesTypes: [],
        currentResource: {},
        currentResources: [],
        resourcePaginationIndex: 0
    },
    mutations: {
        // SET
        SET_RESOURCE(state: IState, payload: any) {
            const { data, uid } = payload;
            // console.info("do u call?", data, uid);
            state.resources.forEach(resource => {
                if (resource.uid === uid) {
                    resource.content = data;
                }
            });
        },
        SET_RESOURCES_TYPE(state: IState, payload: any) {
            state.resourcesTypes = payload
        },
        // ADD
        ADD_RESOURCE(state: IState, payload: any) {
            state.resources.push(payload);
        },
        // DROP OR RESET
        DROP_RESOURCE(state: IState, payload: any) {
            const filteredResources = state.resources.filter(resource => {
                return resource.uid !== payload;
            });
            state.resources = filteredResources;
        },
        RESET_RESOURCES(state: IState, payload: any) {
            state.resources = [];
        },

        // PREVIEW DE ACTIVIDADES Y RECURSOS

        // currentResourece
        SET_CURRENT_RESOURCE(state: any, payload: any) {
            state.currentResource = payload;
        },
        RESET_CURRENT_RESOURCE(state: any) {
            state.currentResource = {};
        },
        
        // currentResources
        SET_CURRENT_RESOURCES(state: any, payload: any) {
            state.currentResources = payload;
            console.info("SETEANDO CURRENT-RESOURCES", payload);
        },
        RESET_CURRENT_RESOURCES(state: any) {
            state.currentResources = [];
        },
        // resourcePaginationIndex
        SET_RESOURCE_PAGINATION_INDEX(state: any, payload: number) {
            state.resourcePaginationIndex = payload
        },
        RESET_RESOURCE_PAGINATION_INDEX(state: any) {
            state.resourcePaginationIndex = 0
        },
    },
    actions: {
        addNewResource(context: any, payload: any) {
            context.commit("ADD_RESOURCE", payload);
        },
        async getAllResourceTypes(context: any) {
            await axios
                .get(
                    `${axios.defaults.baseURL}resourceType`
                )
                .then(res => {
                    console.info("Listado de tipos de recursos", res.data);
                    context.commit("SET_RESOURCES_TYPE", res.data);
                    return true
                })
                .catch(error => {
                    console.info("Error al cargar Listado de tipos de recursos", error);
                    return false
                });
        },
        setResources(context: any, payload: any) {
            context.commit("SET_RESOURCE", payload);
        },
        removeResource(context: any, payload: any) {
            const { uid } = payload;
            context.commit("DROP_RESOURCE", uid);
        },
        actionResetResources(context: any) {
            console.info("--- Store-Function actionResetResources");
            context.commit("RESET_RESOURCES");
        },

        // PREVIEW DE ACTIVIDADES Y RECURSOS

        actionSetCurrentResource(context: any, payload: any) {
            console.info("SETEANDO RECURSO", payload);
            context.commit("SET_CURRENT_RESOURCE", payload);
        },
        actionResetCurrentResource(context: any) {
            context.commit("RESET_CURRENT_RESOURCE");
        },

        async actionGetPdf(context: any, payload: any) {
            try {
                const response = await axios.get(`${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/${payload.resourcesId}`, {
                    responseType: 'blob'
                })

                const url = window.URL.createObjectURL(new Blob([response.data]))
                
                console.info("Response get pdf", url);
                
                // const blob = new Blob([response.data],{ type: 'application/pdf'});
                // context.commit("SET_CURRENT_PDF", blob);

            } catch (error) {
                console.info("Error Peticion PDF", error)
            }

            console.info("SETEANDO PDF", payload);
            context.commit("SET_CURRENT_PDF", payload);
        },
        actionResetCurrentPDF(context: any) {
            context.commit("RESET_CURRENT_PDF");
        },

        // currentResources
        actionSetCurrentResources(context: any, payload: any) {
            context.commit("SET_CURRENT_RESOURCES", payload);
        },
        actionResetCurrentResources(context: any) {
            context.commit("RESET_CURRENT_RESOURCES");
        },

        // resourcePaginationIndex
        actionSetResourcePaginationIndex(context: any, payload: number) {
            context.commit("SET_RESOURCE_PAGINATION_INDEX", payload);
            console.info("SET RESOURCE PAGINATION INDEX", payload);
        },

        actionResetResourcePaginationIndex(context: any) {
            context.commit("RESET_RESOURCE_PAGINATION_INDEX");
            console.info("RESET RESOURCE PAGINATION INDEX");
        },
    },
    getters: {
        getResources(state: IState) {
            return state.resources;
        },
        getResourcesTypes(state: IState) {
            return state.resourcesTypes;
        },

        // PREVIEW DE ACTIVIDADES Y RECURSOS

        getCurrentResource(state: any) {
            return state.currentResource;
        },
        getCurrentResources(state: any) {
            return state.currentResources;
        },
        getResourcePaginationIndex(state: any) {
            return state.resourcePaginationIndex;
        }
    }
};
